<template>
  <div class="container mymessage">
        <ul>
          <li class="card_item" v-for="item in myCards.notReads">
            <a :href="item.url">
             <p class="date">{{item.cdateString}}</p>
             <div class="item_wrap">
               <div class="card_des">
                 <img :src="item.viewImg" alt="">
                 <p>{{item.title}}</p>
               </div>
               <div class="btn_wrap" v-if="item.hasWelfare==1">
                  <a :href="item.url">福利<i class="arrow_right"></i>
                </a>
               </div>
             </div>
             </a>
          </li>
        </ul>
        <div class="no-data" v-if="!loading&&myCards.notReads.length==0">
         <p>暂无关怀消息</p>
      </div>
      
        <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	loading:true,
      myCards:{
        notReads:[]
      }
    }
  },
  components:{
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
      gmyCards:'getmyCards',
      isShowMergeNav:'getisShowMergeNav'
    }),

  },
  watch:{
    gmyCards(cval){
      if(cval){
        this.loading=false
        this.myCards=cval
      }
    }
  },
  created(){
    this.$store.dispatch('loadMyCards')
  },
  methods:{

  },
  mounted(){}
}
</script>